import { Box } from "@mui/material";
import ThemeContext from "components/app/Context";
import DropDown from "components/common/dropdowns/DropDown";
import Typography from "components/common/Typography";
import React, { useContext, useState } from "react";
import { tokens } from "styles/Tokens";
import { converter_ArrayString } from "utils/CommonFunctions";
import DateRangePickerCalendar from "../DateRangePickerCalendar";
import "./react-datepicker.scss";

interface DateRange {
  startDate: Date | null;
  endDate: Date | null;
}

interface DateRangeCalendarProps {
  onDateChange?: (date: Date | null) => void;
  onRangeChange?: (range: DateRange) => void;
  dateRange?: any;
  setDateRange?: any;
}

const DateRangeCalendar: React.FC<DateRangeCalendarProps> = ({
  onDateChange,
  onRangeChange,
  dateRange,
  setDateRange
}) => {
  const [selectedDateRange, setSelectedDateRange] = useState<string>("1 Month");
  const dateRanges: string[] = ["1 Month", "3 Month", "6 Month", "12 Month", "Custom Dates"];
  const { isMobileScreen } = useContext(ThemeContext);

  const handleDateRangeChange = (value: string) => {
    setSelectedDateRange(value);
    setDateRange({ startDate: null, endDate: null });

    if (value === "Custom Dates") {
      return;
    }

    const endDate = new Date();
    let startDate: Date | null = null;

    switch (value) {
      case "1 Month":
        startDate = new Date(endDate.getFullYear(), endDate.getMonth() - 1, endDate.getDate());
        break;
      case "3 Month":
        startDate = new Date(endDate.getFullYear(), endDate.getMonth() - 3, endDate.getDate());
        break;
      case "6 Month":
        startDate = new Date(endDate.getFullYear(), endDate.getMonth() - 6, endDate.getDate());
        break;
      case "12 Month":
        startDate = new Date(endDate.getFullYear() - 1, endDate.getMonth(), endDate.getDate());
        break;
    }
    const newRange = { startDate, endDate };
    setDateRange(newRange);
    onRangeChange?.(newRange);
    onDateChange?.(null);
  };

  return (
    <div className="date-range-calendar-container">
      <div className="date-selector">
        <div className="dropdown-container">
          <DropDown
            label="Select Range"
            handleChangeUpdate={(val) => handleDateRangeChange(val)}
            options={converter_ArrayString(dateRanges)}
            initialValue={"Select a date range"}
            sx={{ width: isMobileScreen ? "100%" : "284px" }}
          />
        </div>
        <div>
          {selectedDateRange === "Custom Dates" && (
            <div className="custom-date-wrapper">
              <Box width={isMobileScreen ? "100%" : "284px"} display={"flex"} flexDirection={"column"}>
                <Typography variant={"body2"} color={tokens.Text.General.PrimaryHeadline}>
                  Custom Date
                </Typography>
                <DateRangePickerCalendar onChange={(range: any) => setDateRange(range)} />
              </Box>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DateRangeCalendar;
